var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcApple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "27px",
    viewBox: "0 0 22 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icApple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Splash-screen",
    transform: "translate(-203.000000, -530.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(203.000000, 530.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icApple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3135229,1.31916472 C9.68208583,1.31916472 8.43795123,0.204329547 6.45972954,0.204329547 C4.52232358,0.204329547 2.45561818,1.42105505 1.14355669,3.49461272 C-0.698513294,6.41785236 -0.385990019,11.9241013 2.59862216,16.6149297 C3.66578934,18.2940347 5.09344571,20.1772184 6.96292479,20.1974773 C8.621473,20.1974773 9.10440935,19.102901 11.340932,19.0894944 C13.5774546,19.0894944 14.0192773,20.190625 15.6373077,20.190625 C17.5407502,20.1703661 19.0431858,18.0834018 20.110353,16.4108511 C20.8787014,15.2078302 21.1641135,14.6027446 21.7554945,13.2430151 C17.4388599,11.5570578 16.7452906,5.26220147 21.0145552,2.84871143 C19.709346,1.16960639 17.8806826,0.197477273 16.1539096,0.197477273 C13.869719,0.197477273 12.9044421,1.31916472 11.3135229,1.31916472 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.954124,0 C14.658535,0.0907797382 13.1494748,0.941661924 12.2620928,2.0520774 C11.4587368,3.05833808 10.7981681,4.5520774 11.0570588,6 L11.1609558,6 C12.5405707,6 13.9525469,5.14285714 14.7752062,4.04553216 C15.5720331,3 16.1744082,1.51935117 15.954124,0",
    id: "Fill-4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApple);
export default __webpack_public_path__ + "static/media/icApple.4234e45a0f6bfd799a77bebd64aa3866.svg";
export { ForwardRef as ReactComponent };